import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withPreloading, withRouterConfig } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OverlayContainer } from '@angular/cdk/overlay';

import { APP_ROUTES } from './app.routes';
import { SelectivePreloadStrategy } from './selective-preload.strategy';
import { CustomOverlayContainer } from './custom-overlay-container';
import { NetworkInterceptor } from './standards-mgmt/utils/network.interceptor';
import { MethodPipe } from './standards-mgmt/utils/method.pipe';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      APP_ROUTES,
      withPreloading(SelectivePreloadStrategy),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
      withRouterConfig({
        paramsInheritanceStrategy: 'emptyOnly',
        canceledNavigationResolution: 'replace',
        urlUpdateStrategy: 'deferred',
      })
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    DatePipe,
    MethodPipe,
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: HTTP_INTERCEPTORS, useClass: NetworkInterceptor, multi: true },
  ]
};
